module.exports = __webpack_public_path__ + "img/zhzm-bg.ed0dfa3d.jpg";